import { createAction } from '@reduxjs/toolkit'

import type {
  TGetConfigsResponse,
  TUpdateConfigsResponse
} from '@homepal/api-contract'

import { Category } from 'types/GlobalDashboardGroup'

// tryGetAllConfigs
export const getAll = createAction('get_all_configs')
export const getAllSuccess = createAction<TGetConfigsResponse<Category>>(
  'get_all_configs_success'
)
export const getAllFailed = createAction('get_all_configs_failed')

// tryUpdateConfig
export const update = createAction('update_config')
export const updateSuccess = createAction<
  TUpdateConfigsResponse<Category> & { category: Category }
>('update_config_success')
export const updateFailed = createAction('update_config_failed')
